import { render, staticRenderFns } from "./ChangelogLatestModal.vue?vue&type=template&id=7dd0f66e&scoped=true&"
import script from "./ChangelogLatestModal.vue?vue&type=script&lang=js&"
export * from "./ChangelogLatestModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangelogLatestModal.vue?vue&type=style&index=0&id=7dd0f66e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd0f66e",
  null
  
)

export default component.exports